import { Icon } from 'leaflet';
const serverURL = process.env?.REACT_APP_SERVER || "";
export const MarkerIcon = new Icon({
  iconUrl:`${serverURL}/static/leaflet/marker-icon.png`,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28]
});
